var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Panel',{attrs:{"module":"Treinamento","showFilter":false,"showSearch":false,"showButtons":false}},[_c('div',{attrs:{"slot":"content-main"},slot:"content-main"},[_c('br'),_c('CourseView')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }